import React from "react";

const skillsContent = [
  { skillClass: "p95", skillPercent: "95", skillName: "COMMUNICATION" },
  { skillClass: "p89", skillPercent: "89", skillName: "ANALYTICAL" },
  { skillClass: "p70", skillPercent: "70", skillName: "SIEMENS NX" },
  { skillClass: "p65", skillPercent: "65", skillName: "CATIA" },
  { skillClass: "p65", skillPercent: "65", skillName: "ANSYS WORKBENCH" },
];

const Skills = () => {
  return (
    <>
      {skillsContent.map((val, i) => (
        <div className="col-6 col-md-3 mb-3 mb-sm-5" key={i}>
          <div className={`c100 ${val.skillClass}`}>
            <span>{val.skillPercent}%</span>
            <div className="slice">
              <div className="bar"></div>
              <div className="fill"></div>
            </div>
          </div>
          <h6 className="text-uppercase open-sans-font text-center mt-2 mt-sm-4">
            {val.skillName}
          </h6>
        </div>
      ))}
    </>
  );
};

export default Skills;
